import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import AdminGateway from '~apis/admin';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TEditAdminDetailsReduxParams } from '~types/feat/admin';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { AuthUserStatusEnum } from '~utils/enums';

export default function* watchDeleteAdmin(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('admin/adminDeleteAdminAttempt', handleDeleteAdmin, api);
}

function* handleDeleteAdmin(api: AdminGateway, data: PayloadAction<TEditAdminDetailsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const { status: _status, ...restOfDataPayload } = data.payload;

    const response = yield* call([api, api.editAdminDetails], {
        authToken,
        ...restOfDataPayload,
        status: AuthUserStatusEnum.Deactivated,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.adminDeleteAdminFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const adminListing = reduxState.admin.adminListing.data;

        const massagedAdminListing = adminListing.map(item => {
            if (item.userId === data.payload.userId) {
                return {
                    ...item,
                    status: AuthUserStatusEnum.Deactivated,
                    updatedAt: dayjs().toISOString(),
                };
            }

            return item;
        });

        yield put(combinedActions.adminSetAdminListingData(massagedAdminListing));
        yield put(combinedActions.adminDeleteAdminSuccess());
        yield put(combinedActions.adminSetDeleteAdminModalIsOpen(false));

        toast.success(SuccessMessages.AdminDeleteAdminSuccess);
    }
}
